import store from 'store';
import { makeRequest } from 'utils/requestLogger';
import config from 'services/apiConfigs';

export default (id, payload) => {
  const url = `${config.apiURL}/api${payload.path}`;
  const p = makeRequest('put', `/api/roundtables/${id}`, {
    thumbnail_url: url,
  });

  return p.then((rt) => {
    const { thumbnail_url } = rt;
    store.dispatch('updateRTDetails', { thumbnail_url });
    return null;
  });
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/changeRTImage.js